import API from "../../services/api";

export async function getEmployeeManager(employeeId) {
  const { data } = await API.get(`/employees/${employeeId}/manager`);
  return data;
}

export async function getDirectReports(employeeId) {
  const { data } = await API.get(`/employees/${employeeId}/direct-reports`);
  return data;
}

export async function getEmployeeHierarchy(employeeId, maxDepth = 50) {
  const { data } = await API.get(`/employees/${employeeId}/hierarchy`, {
    params: { max_depth: maxDepth },
  });
  return data;
}

export async function getManagerChain(employeeId) {
  const { data } = await API.get(`/employees/${employeeId}/manager-chain`);
  return data;
}

export async function getHierarchyLevel(employeeId) {
  const { data } = await API.get(`/employees/${employeeId}/hierarchy-level`);
  return data;
}

export async function getSpanOfControl(employeeId) {
  const { data } = await API.get(`/employees/${employeeId}/span-of-control`);
  return data;
}

export async function assignManager(employeeId, payload) {
  const { data } = await API.post(`/employees/${employeeId}/manager`, payload);
  return data;
}

export async function changeManager(employeeId, payload) {
  const { data } = await API.put(`/employees/${employeeId}/manager`, payload);
  return data;
}

export async function removeManager(employeeId) {
  const { data } = await API.delete(`/employees/${employeeId}/manager`);
  return data;
}

export async function getOrgHierarchyForest(maxDepth = 3) {
  const { data } = await API.get("/organisation/hierarchy", {
    params: { max_depth: maxDepth },
  });
  return data;
}

export async function getOrgHierarchySubtree(employeeId, maxDepth = 50) {
  const { data } = await API.get(`/organisation/hierarchy/${employeeId}`, {
    params: { max_depth: maxDepth },
  });
  return data;
}

/** Super Admin — Org → Location → Department → Designation → Employee */
export async function getOrgLocationStructure() {
  const { data } = await API.get("/organisation/location-structure");
  return data;
}
